import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/privacy/PrivacyContent.tsx");
